import { Box, Paper, styled } from '@mui/material';
import { AssetState } from '@/api/generatedApi';
import { BodyText } from '../BodyText';
import { TitleText } from '../TitleText';

const ZeroStateBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
});

const getHeadingAndMessage = (
  state?: AssetState.Unsupported | AssetState.Indexing,
  errorMessage?: string
): { heading: string; message: string } => {
  if (state === AssetState.Unsupported) {
    return {
      heading: 'Asset Failed to Index',
      message: 'This asset is unsupported and cannot be displayed in the viewer.',
    };
  }

  if (state === AssetState.Indexing) {
    return {
      heading: 'Indexing Asset',
      message:
        "We're processing your asset to enable search and matching features. This may take a few minutes depending on the size and complexity of the model. Please check back later.",
    };
  }

  return { heading: 'Error', message: errorMessage || 'An error occurred. Please try again later.' };
};

export const AssetErrorMessage = ({
  assetState,
  errorMessage,
}: {
  assetState?: AssetState.Unsupported | AssetState.Indexing;
  errorMessage?: string;
}) => {
  const { heading, message } = getHeadingAndMessage(assetState, errorMessage);

  return (
    <ZeroStateBox>
      <Paper elevation={3} sx={{ padding: 4, maxWidth: 400, textAlign: 'center' }}>
        <TitleText sx={{ marginBottom: 2 }}>{heading}</TitleText>
        <BodyText color='text.secondary'>{message}</BodyText>
      </Paper>
    </ZeroStateBox>
  );
};
